export enum IDENTITIES_DEFAULT_FIELDS {
  DEPARTMENT = 'DEPARTMENT',
  GRADE = 'GRADE',
  DESIGNATION = 'DESIGNATION',
  NIC = 'NIC',
  ADDRESS = 'ADDRESS',
}
